import logo from './logo.svg';
import './App.css';
import {BrowserRouter as Router, Routes , Route} from 'react-router-dom';
import Home from './Components/Pages/HomePage/Home';
import About from './Components/Pages/About/About';
import ProductsPage from './Components/Pages/Products/ProductsPage';
import Contact from './Components/Pages/Contact/Contact';
import Bill from './Components/Pages/BillingDetails/Bill';
import Cart from './Components/Pages/Cart/Cart';
import ShopPage from './Components/Pages/MainShop/ShopPage';
import Testimonial from './Components/Pages/Testimonial/Testimonial';
import DetailsPage from './Components/Pages/Details/DetailsPage';
import WhatsAppButton from './Components/Pages/Whatsapp';
import BlogProduct from './Components/Pages/NewsBlog/BlogProduct';
import Blog1 from './Components/Pages/Blog/Blog1';
import SearchResults from './Components/Layout/SearchResults';
import DetailsSection3 from './Components/Pages/Details/DetailsSection3';
import Faq from './Components/Pages/Faq/Faq';
import PaymentPage from './Components/Pages/BillingDetails/PaymentPage1';
import FinalOrder from './Components/Pages/BillingDetails/FinalOrder';
import ProductsAPI2 from './Components/Pages/Products/ProductAPI2';
import Function_Cart10 from './Components/Pages/Cart/Function_Cart11';
import ChatboatMain from './Components/Pages/Courses/ChatboatMain';
import CoursesBooks from './Components/Pages/Courses&Books/CoursesBooks';
import OrderConfirmDynamic from './Components/Pages/Order-Confirm/OrderConfirmDynamic';
import Chatbot from './Components/Pages/Chatbot/Chatbot';
import ProfilePage from './Components/Pages/Profile/ProfilePage';
import Orderlist from './Components/Pages/Order-Confirm/Orderlist1';
import CancelOrder from './Components/Pages/Order-Confirm/CancelOrder';
import OrderCancelled from './Components/Pages/Order-Confirm/OrderCancelled';
import OrderDetails from './Components/Pages/Order-Confirm/OrderDetails';
import ViewOrder from './Components/Pages/Order-Confirm/ViewOrder6';
import ReferPage from './Components/Pages/Profile/RefferandRewards';
import ReferralRewards from './Components/Layout/ReferralRewards';
import Coupon from './Components/Pages/Profile/Coupon';
import TermsCondition from './Components/Layout/TermsCondition';
import PrivacyPolicy from './Components/Layout/PrivacyPolicy';
import ScrollToTop from './Components/Layout/ScrollToTop';
import DualCalendar from './Components/Layout/DualCalendar';
import Ebooks from './Components/Pages/Courses&Books/Ebooks';
import OrderTracking1 from './Components/Pages/OrderTracking1';
import Wishlist from './Components/Pages/Profile/Wishlist';
import ReturnPolicy from './Components/Layout/ReturnPolicy';
import RefundPolicy from './Components/Layout/RefundPolicy';
import Blog2 from './Components/Pages/Blog/Blog2';
import BlogDetails from './Components/Pages/Blog/BlogDetails';
import OfferDetails from './Components/Pages/HomePage/OfferDetails';
import ProductReviews from './Components/Pages/Details/ProductReviews';
import EbookDetail from './Components/Pages/Courses&Books/EbookDetail';
import CourseSectionDetailPage from './Components/Pages/Courses&Books/CourseSectionDetail';
import { useEffect } from 'react';
import Blog from './Components/Pages/Blog/Blog';
import ChatWidget from './Components/ChatBot/ChatWidget';

function App() {

//  useEffect(() => {
//   const script1 = document.createElement("script");
//   script1.src = "https://cdn.botpress.cloud/webchat/v3.6/inject.js";
//   script1.async = true;

//   script1.onload = () => {
//     const script2 = document.createElement("script");
//     script2.src = "https://files.bpcontent.cloud/2025/08/23/10/20250823100403-L5U0JSH3.js";
//     script2.async = true;

//     document.body.appendChild(script2);
//   };

//   document.body.appendChild(script1);
// }, []);

  return (
    <>
    <Router>
       <WhatsAppButton />
       <ScrollToTop/>
       <ChatWidget/>
      <Routes>
        
        <Route exact path='/' element={<Home/>}/>
        <Route path='/About' element={<About/>}/>
         <Route path='/ProductsPage' element={<ProductsPage/>}/>
         <Route path="/Cart" element={<Cart />} />
         <Route path="/Bill" element={<Bill />} />
         <Route  path='/Contact' element={<Contact/>}/>
         <Route path='/ShopPage' element={<ShopPage/>}/>
         <Route path='/Testimonial' element={<Testimonial/>}/>
         <Route path='/DetailsPage' element={<DetailsPage/>}/>
      
              <Route path='/DetailsSection3/:prod_id' element={<DetailsSection3/>}/>

<Route path='/products' element={<ProductsAPI2/>}/>
<Route path='/payment' element={<PaymentPage/>}/>
<Route path='/finalorder' element={<FinalOrder/>}/>
<Route path='/coupon' element={<Coupon/>}/>



<Route path='/functioncart' element={<Function_Cart10/>}/>

{/* <Route path='/blog' element={<Blog1/>}/>    */}
<Route path='/Blog' element={<Blog2/>}/>
{/* <Route path='/Blog' element={<Blog/>}/> */}
{/* <Route path='/blog1' element={<BlogProduct/>}/> */}
<Route path='/coursesection' element={<CoursesBooks/>}/>
<Route path='/coursesectiondetail/:id' element={<CourseSectionDetailPage/>}/>
<Route path='/chatboat' element={<ChatboatMain/>}/>
<Route path='/chatbot' element={<Chatbot/>}/>
<Route path='/Ebooks' element={<Ebooks/>}/>
<Route path="/search" element={<SearchResults/>} />
<Route path='/faq' element={<Faq/>}/>
 <Route path='/order-confirm' element={<OrderConfirmDynamic/>}/>
 <Route path='/orderlist' element={<Orderlist/>}/>
 <Route path='/cancelorder' element={<CancelOrder/>}/>
 <Route path='/ordercancelled' element={<OrderCancelled/>}/>
 <Route path='/orderdetails' element={<OrderDetails/>}/>
 <Route path='/vieworder' element={<ViewOrder/>}/>
 <Route path='/profile' element={<ProfilePage/>}/>
 <Route path='/referral' element={<ReferPage/>}/>
 <Route path='/referralrewards' element={<ReferralRewards/>}/>
 <Route path='/termscondition' element={<TermsCondition/>}/>
 <Route path='/privacypolicy' element={<PrivacyPolicy/>}/>
 <Route path='/returnpolicy' element={<ReturnPolicy/>}/>
 <Route path='/refundpolicy' element={<RefundPolicy/>}/>
 <Route path='/dualcalendar' element={<DualCalendar/>}/>
 <Route path="/track-order/:orderId" element={<OrderTracking1/>} />
 <Route path='/Wishlist' element={<Wishlist/>}/>
 <Route path='/blog/:id' element={<BlogDetails/>}/>
 <Route path='/offer/:id' element={<OfferDetails/>}/>
 <Route path='/reviews/:prod_id' element={<ProductReviews/>}/>
 <Route path="/EbookDetail/:prod_id" element={<EbookDetail/>} />
      </Routes>
    </Router>
    </>
  );
}

export default App;
